<template>
  <generic-modal v-if="canDisplayDepartmentSelector" :has-close-button="true" @close="closeModal">
    <template #header />
    <template #body>
      <div class="rte" v-html="welcometext"/>
      <form @submit="onSelectDepartment">
        <select v-model="ppwRecId" class="form-group">
          <option v-for="(item, index) in availableDepartments" :key="index" :data-index="index" :value="item.ppwRecId">
            {{ item.name }}
          </option>
        </select>
        <v-button class="department-submit-button" primary md @click="onSelectDepartment"> Selecteer </v-button>
      </form>
    </template>
  </generic-modal>
</template>
<script>
import GenericModal from '@/components/shared/GenericModal';
import { availableDepartments$, activePpwRecId$, currentUserIdentity$, } from '@/services';
import router from '@/router';
import { pushDepartmentChangedEvent } from '@/components/sections/navigation/departmentChangedEventStream';
import { computed, ref, watchEffect } from 'vue';
import { useStore, mapActions } from 'vuex';

export default {
  name: 'Departments',
  components: { GenericModal },
  setup() {
    const store = useStore();
    const availableDepartments = ref(null);
    const ppwRecId = ref(null);
    const selectedDepartmentChange = (value) => store.dispatch('login/selectedDepartmentChange', value);
    const welcometext = ref('');
    const fetchNewsItems = () => store.dispatch('news/fetchNewsItems', 3);
    const fetchDepotMaterialDetails = () => store.dispatch('navigation/fetchDepotMaterialDetails');
    const fetchResults = () => store.dispatch('navigation/fetchResults');
    const redirectedFromRegistration = window.localStorage.getItem('redirectedFromRegistration');
    // availableDepartments subscription
    // watchEffect(() => {
    //   availableDepartments.value = availableDepartments$.value;
    // });
  currentUserIdentity$.subscribe((value) => {
      welcometext.value = "<p>Welkom " + value.initials + " "+ value.lastName + " " + value.prePostion+ "</p>\n"+"<p>Selecteer hieronder voor welke afdeling/locatie u in wilt loggen:</p>";
    });
    availableDepartments$.subscribe((value) => {
      availableDepartments.value = value;
    });

    activePpwRecId$.subscribe((value) => {
      ppwRecId.value = value;
    });

    const canDisplayDepartmentSelector = computed(() => {
      return availableDepartments.value && availableDepartments.value.length > 1;
    });

    return {
      availableDepartments,
      ppwRecId,
      selectedDepartmentChange,
      fetchNewsItems,
      fetchDepotMaterialDetails,
      fetchResults,
      welcometext,
      canDisplayDepartmentSelector,
      ...mapActions('login', ['selectedDepartmentChange']),
      redirectedFromRegistration
    };
  },
  data() {
    return {
      errorMessage: ''
    };
  },
  created() {
  },
  methods: {
    onSelectDepartment: function (e) {
      e.preventDefault();
      this.selectedDepartmentChange(this.ppwRecId).then((response) => {
        if (this.redirectedFromRegistration === false) {
          router.push('/');
        }
        this.closeModal();
        this.fetchDepotMaterialDetails();
        this.fetchResults();
        pushDepartmentChangedEvent({});
        this.fetchDepotMaterialDetails();
        this.fetchNewsItems();
      });
    },
    closeModal() {
      this.$emit('close');
      window.localStorage.removeItem('redirectedFromRegistration');
    }
  }
};
</script>

<style lang="scss" scoped>
.department-submit-button {
  float: right;
  margin: 15px 0 15px 0;
}

.form-group {
  padding: 9px 0 9px;
  color: $gray-dark;
  width: 100%;
  border-radius: 3px;
  border: 1px solid $gray;
}
</style>
